export enum LessonType {
  LESSON = 0,
  MICROLESSON = 1,
  MICROREEL = 2,
}
